// import React, { useState, useEffect, useRef } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/free-mode";
// import "swiper/css/pagination";
// import 'swiper/css/navigation';
// import { FreeMode, Mousewheel, Pagination, Navigation } from "swiper/modules";
// import UpcomingTripsBtn from "./UpcomingTripsBtn";
// import YoutubeUrlAPI from "../api/YoutubeUrlAPI";
// import {
//   MdVolumeOff,
//   MdVolumeUp,
//   MdPlayArrow,
//   MdPause,
//   MdFullscreen,
//   MdClose,
// } from "react-icons/md";
// import { FaLink } from "react-icons/fa";

// const Hero = () => {
//   const [videoData, setVideoData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [activeVideoIndex, setActiveVideoIndex] = useState(0);
//   const [videoStates, setVideoStates] = useState({});
//   const [fullscreenVideo, setFullscreenVideo] = useState(null);
//   const videoRefs = useRef([]);
//   const containerRefs = useRef([]);
//   const fullscreenOverlayRef = useRef(null);
//   const swiperRef = useRef(null);
//   const [videosLoaded, setVideosLoaded] = useState(false);
//   const fullscreenVideoRef = useRef(null);
//   const [hoveredIndex, setHoveredIndex] = useState(null);
//   const youtubeIframeRefs = useRef([]);
//   const fullscreenYoutubeRef = useRef(null);

//   // Function to extract YouTube ID from various URL formats
//   const getYouTubeId = (url) => {
//     // Handle YouTube Shorts URLs
//     if (url.includes('youtube.com/shorts/')) {
//       const match = url.match(/youtube\.com\/shorts\/([^?#&/]+)/);
//       return match ? match[1] : null;
//     }

//     // Handle regular YouTube URLs
//     const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
//     const match = url.match(regExp);
//     return (match && match[2].length === 11) ? match[2] : null;
//   };

//   // Function to get YouTube embed URL - NEVER show YouTube controls
//   const getYouTubeEmbedUrl = (url, autoplay = 1, mute = 1) => {
//     const videoId = getYouTubeId(url);
//     // Always set controls=0 and disable keyboard controls and related videos
//     return videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=${autoplay}&mute=${mute}&playsinline=1&modestbranding=1&rel=0&controls=0&disablekb=1&fs=0&iv_load_policy=3` : null;
//   };

//   useEffect(() => {
//     const fetchUrls = async () => {
//       try {
//         const response = await YoutubeUrlAPI.getYoutubeUrl();

//         // Process both direct video URLs and YouTube URLs
//         const processedData = response.data.flatMap((item) =>
//           item.urls.map((url) => {
//             // Check if it's a YouTube URL (including Shorts)
//             if (url.includes('youtube.com') || url.includes('youtu.be')) {
//               const embedUrl = getYouTubeEmbedUrl(url, 1, 1);
//               if (embedUrl) {
//                 return {
//                   type: "youtube",
//                   url: embedUrl,
//                   originalUrl: url,
//                   video_title: item.video_title,
//                   video_url: item.video_url || null,
//                   id: item.id,
//                 };
//               }
//             }

//             // Check if it's a direct video URL
//             if (url.match(/\.(mp4|webm|ogg)$/i)) {
//               return {
//                 type: "video",
//                 url: url,
//                 originalUrl: url,
//                 video_title: item.video_title,
//                 video_url: item.video_url || null,
//                 id: item.id,
//               };
//             }

//             return null;
//           }).filter(Boolean) // Remove null entries
//         );

//         setVideoData(processedData);

//         // Initialize video states
//         const initialState = {};
//         processedData.forEach((_, index) => {
//           initialState[index] = {
//             isPlaying: true,
//             isMuted: true,
//             isFullscreen: false,
//           };
//         });
//         setVideoStates(initialState);

//         setLoading(false);
//       } catch (err) {
//         setError(err.message);
//         setLoading(false);

//         // Fallback to sample videos if API fails
//         const fallbackData = [
//           {
//             type: "video",
//             url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
//             originalUrl: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
//             video_title: "Sample Video 1",
//           },
//           {
//             type: "youtube",
//             url: getYouTubeEmbedUrl("https://www.youtube.com/shorts/5h5sx5o5N5w", 1, 1),
//             originalUrl: "https://www.youtube.com/shorts/5h5sx5o5N5w",
//             video_title: "Sample YouTube Short",
//           },
//         ];

//         setVideoData(fallbackData);

//         const initialState = {};
//         fallbackData.forEach((_, index) => {
//           initialState[index] = {
//             isPlaying: true,
//             isMuted: true,
//             isFullscreen: false,
//           };
//         });
//         setVideoStates(initialState);
//       }
//     };

//     fetchUrls();
//   }, []);

//   // Handle autoplay for all videos when they are loaded
//   useEffect(() => {
//     if (videoData.length > 0 && !videosLoaded) {
//       const playAllVideos = async () => {
//         try {
//           const playPromises = [];

//           videoRefs.current.forEach((video, index) => {
//             if (video && videoData[index].type === "video") {
//               video.muted = true;
//               playPromises.push(
//                 video
//                   .play()
//                   .then(() => {
//                     setVideoStates((prev) => ({
//                       ...prev,
//                       [index]: {
//                         ...prev[index],
//                         isPlaying: true,
//                         isMuted: true,
//                       },
//                     }));
//                   })
//                   .catch((error) => {
//                     console.error(`Error autoplaying video ${index}:`, error);
//                     setVideoStates((prev) => ({
//                       ...prev,
//                       [index]: {
//                         ...prev[index],
//                         isPlaying: false,
//                       },
//                     }));
//                   })
//               );
//             } else if (videoData[index].type === "youtube") {
//               // For YouTube videos, we consider them as playing by default
//               setVideoStates((prev) => ({
//                 ...prev,
//                 [index]: {
//                   ...prev[index],
//                   isPlaying: true,
//                   isMuted: true,
//                 },
//               }));
//             }
//           });

//           await Promise.all(playPromises);
//           setVideosLoaded(true);
//         } catch (error) {
//           console.error("Error autoplaying videos:", error);
//         }
//       };

//       setTimeout(() => {
//         playAllVideos();
//       }, 100);
//     }
//   }, [videoData, videosLoaded]);

//   // Handle slide change to ensure active video is playing
//   useEffect(() => {
//     if (videosLoaded && videoRefs.current[activeVideoIndex] &&
//       videoData[activeVideoIndex]?.type === "video") {
//       const ensureActiveVideoPlaying = async () => {
//         try {
//           if (videoRefs.current[activeVideoIndex].paused) {
//             await videoRefs.current[activeVideoIndex].play();

//             setVideoStates((prev) => ({
//               ...prev,
//               [activeVideoIndex]: {
//                 ...prev[activeVideoIndex],
//                 isPlaying: true,
//               },
//             }));
//           }
//         } catch (error) {
//           console.error("Error playing active video:", error);
//         }
//       };

//       ensureActiveVideoPlaying();
//     }
//   }, [activeVideoIndex, videosLoaded, videoData]);

//   const toggleMute = (index, e) => {
//     e.stopPropagation();

//     if (videoData[index].type === "video" && videoRefs.current[index]) {
//       const newMutedState = !videoRefs.current[index].muted;
//       videoRefs.current[index].muted = newMutedState;

//       setVideoStates((prev) => ({
//         ...prev,
//         [index]: {
//           ...prev[index],
//           isMuted: newMutedState,
//         },
//       }));
//     } else if (videoData[index].type === "youtube") {
//       // For YouTube videos, we need to reload the iframe with new mute parameter
//       const newMutedState = !videoStates[index]?.isMuted;
//       const newUrl = getYouTubeEmbedUrl(
//         videoData[index].originalUrl,
//         1,
//         newMutedState ? 1 : 0
//       );

//       // Update the iframe src
//       if (youtubeIframeRefs.current[index]) {
//         youtubeIframeRefs.current[index].src = newUrl;
//       }

//       setVideoStates((prev) => ({
//         ...prev,
//         [index]: {
//           ...prev[index],
//           isMuted: newMutedState,
//         },
//       }));
//     }
//   };

//   const toggleFullscreen = (index, e) => {
//     e.stopPropagation();

//     // For both video types, use our custom fullscreen
//     setFullscreenVideo({
//       index,
//       url: videoData[index].url,
//       originalUrl: videoData[index].originalUrl,
//       type: videoData[index].type,
//       isMuted: videoStates[index]?.isMuted,
//       isPlaying: videoStates[index]?.isPlaying,
//       title: videoData[index].video_title
//     });

//     // Pause the original video if it's a regular video
//     if (videoData[index].type === "video" && videoRefs.current[index]) {
//       videoRefs.current[index].pause();
//     }
//   };

//   const exitFullscreen = () => {
//     if (fullscreenVideo && fullscreenVideo.isPlaying &&
//       videoData[fullscreenVideo.index]?.type === "video" &&
//       videoRefs.current[fullscreenVideo.index]) {
//       videoRefs.current[fullscreenVideo.index].play();
//     }

//     setFullscreenVideo(null);
//   };

//   const toggleFullscreenMute = () => {
//     if (fullscreenVideo) {
//       if (fullscreenVideo.type === "video") {
//         setFullscreenVideo((prev) => ({
//           ...prev,
//           isMuted: !prev.isMuted,
//         }));
//       } else if (fullscreenVideo.type === "youtube") {
//         // For YouTube in fullscreen, we need to reload the iframe
//         const newMutedState = !fullscreenVideo.isMuted;
//         const newUrl = getYouTubeEmbedUrl(
//           fullscreenVideo.originalUrl,
//           fullscreenVideo.isPlaying ? 1 : 0,
//           newMutedState ? 1 : 0
//         );

//         if (fullscreenYoutubeRef.current) {
//           fullscreenYoutubeRef.current.src = newUrl;
//         }

//         setFullscreenVideo((prev) => ({
//           ...prev,
//           isMuted: newMutedState
//         }));
//       }
//     }
//   };

//   const toggleFullscreenPlayPause = () => {
//     if (fullscreenVideo) {
//       if (fullscreenVideo.type === "video") {
//         if (fullscreenVideoRef.current.paused) {
//           fullscreenVideoRef.current.play();
//           setFullscreenVideo((prev) => ({ ...prev, isPlaying: true }));
//         } else {
//           fullscreenVideoRef.current.pause();
//           setFullscreenVideo((prev) => ({ ...prev, isPlaying: false }));
//         }
//       } else if (fullscreenVideo.type === "youtube") {
//         // For YouTube in fullscreen, we need to reload the iframe
//         const newPlayingState = !fullscreenVideo.isPlaying;
//         const newUrl = getYouTubeEmbedUrl(
//           fullscreenVideo.originalUrl,
//           newPlayingState ? 1 : 0,
//           fullscreenVideo.isMuted ? 1 : 0
//         );

//         if (fullscreenYoutubeRef.current) {
//           fullscreenYoutubeRef.current.src = newUrl;
//         }

//         setFullscreenVideo((prev) => ({
//           ...prev,
//           isPlaying: newPlayingState
//         }));
//       }
//     }
//   };

//   const togglePlayPause = (index, e) => {
//     e.stopPropagation();
//     if (videoData[index].type === "video" && videoRefs.current[index]) {
//       if (videoRefs.current[index].paused) {
//         videoRefs.current[index].play();

//         setVideoStates((prev) => ({
//           ...prev,
//           [index]: {
//             ...prev[index],
//             isPlaying: true,
//           },
//         }));
//       } else {
//         videoRefs.current[index].pause();

//         setVideoStates((prev) => ({
//           ...prev,
//           [index]: {
//             ...prev[index],
//             isPlaying: false,
//           },
//         }));
//       }
//     } else if (videoData[index].type === "youtube") {
//       // For YouTube videos, we need to reload the iframe with new autoplay parameter
//       const newPlayingState = !videoStates[index]?.isPlaying;
//       const newUrl = getYouTubeEmbedUrl(
//         videoData[index].originalUrl,
//         newPlayingState ? 1 : 0,
//         videoStates[index]?.isMuted ? 1 : 0
//       );

//       // Update the iframe src
//       if (youtubeIframeRefs.current[index]) {
//         youtubeIframeRefs.current[index].src = newUrl;
//       }

//       setVideoStates((prev) => ({
//         ...prev,
//         [index]: {
//           ...prev[index],
//           isPlaying: newPlayingState,
//         },
//       }));
//     }
//   };

//   const handleVideoClick = (index, e) => {
//     e.stopPropagation();
//     if (videoData[index].type === "video") {
//       togglePlayPause(index, e);
//     } else if (videoData[index].type === "youtube") {
//       // For YouTube videos, toggle play/pause on click
//       togglePlayPause(index, e);
//     }
//   };

//   // Add event listeners for video play/pause to keep UI in sync
//   useEffect(() => {
//     const playListeners = [];
//     const pauseListeners = [];

//     videoRefs.current.forEach((video, index) => {
//       if (video && videoData[index]?.type === "video") {
//         const playHandler = () => {
//           setVideoStates((prev) => ({
//             ...prev,
//             [index]: {
//               ...prev[index],
//               isPlaying: true,
//             },
//           }));
//         };

//         const pauseHandler = () => {
//           setVideoStates((prev) => ({
//             ...prev,
//             [index]: {
//               ...prev[index],
//               isPlaying: false,
//             },
//           }));
//         };

//         video.addEventListener("play", playHandler);
//         video.addEventListener("pause", pauseHandler);

//         playListeners[index] = playHandler;
//         pauseListeners[index] = pauseHandler;
//       }
//     });

//     return () => {
//       videoRefs.current.forEach((video, index) => {
//         if (video && playListeners[index] && pauseListeners[index]) {
//           video.removeEventListener("play", playListeners[index]);
//           video.removeEventListener("pause", pauseListeners[index]);
//         }
//       });
//     };
//   }, [videoData]);

//   // Close fullscreen when pressing Escape key
//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (e.key === "Escape" && fullscreenVideo) {
//         exitFullscreen();
//       }
//     };

//     window.addEventListener("keydown", handleKeyDown);
//     return () => {
//       window.removeEventListener("keydown", handleKeyDown);
//     };
//   }, [fullscreenVideo]);

//   if (loading) {
//     return (
//       <div
//         style={{
//           backgroundColor: "#e0e0e0",
//           padding: "30px 0",
//           textAlign: "center",
//         }}
//       >
//         Loading videos...
//       </div>
//     );
//   }

//   return (
//     <>
//       {/* Fullscreen Overlay - For both video types */}
//       {fullscreenVideo && (
//         <div
//           ref={fullscreenOverlayRef}
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100vw",
//             height: "100dvh",
//             backgroundColor: "rgba(0, 0, 0, 0.95)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 9999,
//             cursor: "pointer",
//           }}
//           onClick={exitFullscreen}
//         >
//           <div
//             style={{
//               position: "relative",
//               maxWidth: "90%",
//               maxHeight: "90%",
//               width: "auto",
//               height: "auto",
//               aspectRatio: "9/16",
//             }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             {fullscreenVideo.type === "video" ? (
//               <video
//                 ref={fullscreenVideoRef}
//                 src={fullscreenVideo.url}
//                 style={{
//                   width: "100%",
//                   height: "100%",
//                   objectFit: "contain",
//                   backgroundColor: "#000",
//                 }}
//                 muted={fullscreenVideo.isMuted}
//                 loop
//                 playsInline
//                 autoPlay={fullscreenVideo.isPlaying}
//               />
//             ) : (
//               <iframe
//                 ref={fullscreenYoutubeRef}
//                 src={getYouTubeEmbedUrl(
//                   fullscreenVideo.originalUrl,
//                   fullscreenVideo.isPlaying ? 1 : 0,
//                   fullscreenVideo.isMuted ? 1 : 0
//                 )}
//                 style={{
//                   width: "100%",
//                   height: "100%",
//                   border: "none",
//                   backgroundColor: "#000",
//                 }}
//                 allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                 allowFullScreen={false} // Disable YouTube's fullscreen
//               />
//             )}

//             {/* Title for fullscreen video */}
//             {fullscreenVideo.title && (
//               <div
//                 style={{
//                   position: "absolute",
//                   top: "20px",
//                   left: "0",
//                   width: "100%",
//                   textAlign: "center",
//                   color: "white",
//                   fontSize: "18px",
//                   fontWeight: "bold",
//                   textShadow: "2px 2px 4px rgba(0,0,0,0.7)",
//                   padding: "0 20px",
//                   boxSizing: "border-box",
//                   zIndex: 10,
//                 }}
//               >
//                 {fullscreenVideo.title}
//               </div>
//             )}

//             <div
//               style={{
//                 position: "absolute",
//                 bottom: "20px",
//                 left: "0",
//                 width: "100%",
//                 display: "flex",
//                 justifyContent: "center",
//                 gap: "15px",
//                 zIndex: 10,
//               }}
//             >
//               <div
//                 style={{
//                   backgroundColor: "rgba(0,0,0,0.5)",
//                   borderRadius: "50%",
//                   width: "40px",
//                   height: "40px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   cursor: "pointer",
//                 }}
//                 onClick={toggleFullscreenPlayPause}
//               >
//                 {fullscreenVideo.isPlaying ? (
//                   <MdPause size={24} color="white" />
//                 ) : (
//                   <MdPlayArrow size={24} color="white" />
//                 )}
//               </div>

//               <div
//                 style={{
//                   backgroundColor: "rgba(0,0,0,0.5)",
//                   borderRadius: "50%",
//                   width: "40px",
//                   height: "40px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   cursor: "pointer",
//                 }}
//                 onClick={toggleFullscreenMute}
//               >
//                 {fullscreenVideo.isMuted ? (
//                   <MdVolumeOff size={24} color="white" />
//                 ) : (
//                   <MdVolumeUp size={24} color="white" />
//                 )}
//               </div>

//               <div
//                 style={{
//                   backgroundColor: "rgba(0,0,0,0.5)",
//                   borderRadius: "50%",
//                   width: "40px",
//                   height: "40px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   cursor: "pointer",
//                 }}
//                 onClick={exitFullscreen}
//               >
//                 <MdClose size={24} color="white" />
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className="d-flex align-items-center custom-hero-swiper-safari" style={{ backgroundColor: "#e0e0e0", padding: "30px 0"}}>
//         <Swiper
//           spaceBetween={30}
//           freeMode={true}
//           loop={true}
//           allowTouchMove={true}
//           direction={"horizontal"}
//           mousewheel={{
//             forceToAxis: true,
//             releaseOnEdges: true,
//             sensitivity: 1,
//           }}
//           modules={[FreeMode, Pagination, Mousewheel,Navigation]}
//           className="mySwiper px-5 px-md-0 px-lg-1"
//           style={{ padding: "30px 0" }}
//           breakpoints={{
//             320: { slidesPerView: 1, spaceBetween: 8 },
//             375: { slidesPerView: 1, spaceBetween: 8 },
//             425: { slidesPerView: 1, spaceBetween: 8 },
//             640: { slidesPerView: 1, spaceBetween: 20 },
//             768: { slidesPerView: 3.2, spaceBetween: 24 },
//             1025: { slidesPerView: 5.2, spaceBetween: 30 },
//           }}
//           navigation={true}
//           onSwiper={(swiper) => {
//             swiperRef.current = swiper;
//           }}
//           onSlideChange={(swiper) => {
//             setActiveVideoIndex(swiper.activeIndex);
//           }}
//         >
//           {videoData.map((item, index) => (
//             <SwiperSlide
//               key={index}
//               style={{ aspectRatio: "9/16", padding: "10px" }}
//             >
//               <div
//                 ref={(el) => (containerRefs.current[index] = el)}
//                 style={{
//                   position: "relative",
//                   width: "100%",
//                   paddingTop: "177.78%",
//                   borderRadius: "15px",
//                   overflow: "hidden",
//                   boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                   touchAction: "pan-y",
//                   backgroundColor: "#fff",
//                 }}
//                 onMouseEnter={() => setHoveredIndex(index)}
//                 onMouseLeave={() => setHoveredIndex(null)}
//               >
//                 {item.type === "video" ? (
//                   <video
//                     ref={(el) => (videoRefs.current[index] = el)}
//                     src={item.url}
//                     style={{
//                       position: "absolute",
//                       top: 0,
//                       left: 0,
//                       width: "100%",
//                       height: "100%",
//                       objectFit: "cover",
//                     }}
//                     muted={true}
//                     loop
//                     playsInline
//                     preload="auto"
//                     onClick={(e) => handleVideoClick(index, e)}
//                   />
//                 ) : (
//                   <iframe
//                     ref={(el) => {
//                       youtubeIframeRefs.current[index] = el;
//                       videoRefs.current[index] = el;
//                     }}
//                     src={item.url}
//                     style={{
//                       position: "absolute",
//                       top: 0,
//                       left: 0,
//                       width: "100%",
//                       height: "100%",
//                       border: "none",
//                     }}
//                     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                     allowFullScreen={false} // Disable YouTube's fullscreen
//                     onClick={(e) => handleVideoClick(index, e)}
//                   />
//                 )}

//                 {/* Controls for both video and YouTube */}
//                 <div
//                   style={{
//                     position: "absolute",
//                     top: "12px",
//                     left: "12px",
//                     zIndex: 10,
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: "8px",
//                   }}
//                 >
//                   <div
//                     style={{
//                       backgroundColor: "rgba(0,0,0,0.5)",
//                       borderRadius: "50%",
//                       width: "32px",
//                       height: "32px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       cursor: "pointer",
//                       transition: "background-color 0.2s",
//                     }}
//                     onMouseOver={(e) =>
//                       (e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.7)")
//                     }
//                     onMouseOut={(e) =>
//                       (e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.5)")
//                     }
//                     onClick={(e) => togglePlayPause(index, e)}
//                   >
//                     {videoStates[index]?.isPlaying ? (
//                       <MdPause size={18} color="white" />
//                     ) : (
//                       <MdPlayArrow size={18} color="white" />
//                     )}
//                   </div>

//                   <div
//                     style={{
//                       backgroundColor: "rgba(0,0,0,0.5)",
//                       borderRadius: "50%",
//                       width: "32px",
//                       height: "32px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       cursor: "pointer",
//                       transition: "background-color 0.2s",
//                     }}
//                     onMouseOver={(e) =>
//                       (e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.7)")
//                     }
//                     onMouseOut={(e) =>
//                       (e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.5)")
//                     }
//                     onClick={(e) => toggleMute(index, e)}
//                   >
//                     {videoStates[index]?.isMuted ? (
//                       <MdVolumeOff size={18} color="white" />
//                     ) : (
//                       <MdVolumeUp size={18} color="white" />
//                     )}
//                   </div>

//                   <div
//                     style={{
//                       backgroundColor: "rgba(0,0,0,0.5)",
//                       borderRadius: "50%",
//                       width: "32px",
//                       height: "32px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       cursor: "pointer",
//                       transition: "background-color 0.2s",
//                     }}
//                     onMouseOver={(e) =>
//                       (e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.7)")
//                     }
//                     onMouseOut={(e) =>
//                       (e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.5)")
//                     }
//                     onClick={(e) => toggleFullscreen(index, e)}
//                   >
//                     <MdFullscreen size={18} color="white" />
//                   </div>
//                 </div>

//                 {hoveredIndex === index && item.video_title && (
//                   <div
//                     className="custom-hero-sliders-sticker"
//                   >
//                     <a
//                       href={item.video_url || item.originalUrl}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       style={{
//                         color: "black",
//                         textDecoration: "none",
//                         display: "flex",
//                         alignItems: "center",
//                       }}
//                     >
//                       <span className="me-1">
//                         <FaLink className="custom-video-slider-link-icon" />
//                       </span>
//                       {item.video_title}
//                     </a>
//                   </div>
//                 )}
//               </div>
//             </SwiperSlide>
//           ))}
//           <div className="py-2 text-center my-4 pb-4">
//             <UpcomingTripsBtn />
//           </div>
//         </Swiper>
//       </div>
//     </>
//   );
// };

// export default Hero;




import React, { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import 'swiper/css/navigation';
import { FreeMode, Mousewheel, Pagination, Navigation } from "swiper/modules";
import UpcomingTripsBtn from "./UpcomingTripsBtn";
import YoutubeUrlAPI from "../api/YoutubeUrlAPI";
import {
  MdVolumeOff,
  MdVolumeUp,
  MdPlayArrow,
  MdPause,
  MdFullscreen,
  MdClose,
} from "react-icons/md";
import { FaLink } from "react-icons/fa";

const Hero = () => {
  const [videoData, setVideoData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeVideoIndex, setActiveVideoIndex] = useState(0);
  const [videoStates, setVideoStates] = useState({});
  const [fullscreenVideo, setFullscreenVideo] = useState(null);
  const videoRefs = useRef([]);
  const containerRefs = useRef([]);
  const fullscreenOverlayRef = useRef(null);
  const swiperRef = useRef(null);
  const [videosLoaded, setVideosLoaded] = useState(false);
  const fullscreenVideoRef = useRef(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const youtubeIframeRefs = useRef([]);
  const fullscreenYoutubeRef = useRef(null);
  
  // NEW: Track which videos should be loaded
  const [loadedVideos, setLoadedVideos] = useState(new Set([0])); // Load first video initially
  const observerRef = useRef(null);

  // Function to extract YouTube ID from various URL formats
  const getYouTubeId = (url) => {
    if (url.includes('youtube.com/shorts/')) {
      const match = url.match(/youtube\.com\/shorts\/([^?#&/]+)/);
      return match ? match[1] : null;
    }
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };

  // NEW: Get YouTube thumbnail
  const getYouTubeThumbnail = (url) => {
    const videoId = getYouTubeId(url);
    return videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : null;
  };

  // MODIFIED: Simplified embed URL - removed unnecessary parameters
  const getYouTubeEmbedUrl = (url, autoplay = 1, mute = 1) => {
    const videoId = getYouTubeId(url);
    // Minimal parameters for better performance
    return videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=${autoplay}&mute=${mute}&playsinline=1&controls=0&modestbranding=1&rel=0&enablejsapi=0` : null;
  };

  useEffect(() => {
    const fetchUrls = async () => {
      try {
        const response = await YoutubeUrlAPI.getYoutubeUrl();

        const processedData = response.data.flatMap((item) =>
          item.urls.map((url) => {
            if (url.includes('youtube.com') || url.includes('youtu.be')) {
              const embedUrl = getYouTubeEmbedUrl(url, 1, 1);
              if (embedUrl) {
                return {
                  type: "youtube",
                  url: embedUrl,
                  originalUrl: url,
                  thumbnail: getYouTubeThumbnail(url), // NEW: Add thumbnail
                  video_title: item.video_title,
                  video_url: item.video_url || null,
                  id: item.id,
                };
              }
            }

            if (url.match(/\.(mp4|webm|ogg)$/i)) {
              return {
                type: "video",
                url: url,
                originalUrl: url,
                video_title: item.video_title,
                video_url: item.video_url || null,
                id: item.id,
              };
            }

            return null;
          }).filter(Boolean)
        );

        setVideoData(processedData);

        const initialState = {};
        processedData.forEach((_, index) => {
          initialState[index] = {
            isPlaying: true,
            isMuted: true,
            isFullscreen: false,
          };
        });
        setVideoStates(initialState);

        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);

        const fallbackData = [
          {
            type: "video",
            url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
            originalUrl: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
            video_title: "Sample Video 1",
          },
          {
            type: "youtube",
            url: getYouTubeEmbedUrl("https://www.youtube.com/shorts/5h5sx5o5N5w", 1, 1),
            originalUrl: "https://www.youtube.com/shorts/5h5sx5o5N5w",
            thumbnail: getYouTubeThumbnail("https://www.youtube.com/shorts/5h5sx5o5N5w"),
            video_title: "Sample YouTube Short",
          },
        ];

        setVideoData(fallbackData);

        const initialState = {};
        fallbackData.forEach((_, index) => {
          initialState[index] = {
            isPlaying: true,
            isMuted: true,
            isFullscreen: false,
          };
        });
        setVideoStates(initialState);
      }
    };

    fetchUrls();
  }, []);

  // NEW: Intersection Observer setup for lazy loading
  useEffect(() => {
    if (videoData.length === 0) return;

    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.index);
            setLoadedVideos((prev) => new Set([...prev, index]));
          }
        });
      },
      {
        root: null,
        rootMargin: "50px", // Load videos 50px before they come into view
        threshold: 0.1,
      }
    );

    // Observe all video containers
    containerRefs.current.forEach((container, index) => {
      if (container) {
        container.dataset.index = index;
        observerRef.current.observe(container);
      }
    });

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [videoData]);

  // MODIFIED: Handle slide change - preload nearby videos
  useEffect(() => {
    if (activeVideoIndex >= 0 && videoData.length > 0) {
      const toLoad = new Set([
        activeVideoIndex,
        activeVideoIndex - 1,
        activeVideoIndex + 1,
        activeVideoIndex - 2,
        activeVideoIndex + 2,
      ].filter(i => i >= 0 && i < videoData.length));

      setLoadedVideos(prev => new Set([...prev, ...toLoad]));
    }
  }, [activeVideoIndex, videoData.length]);

  // MODIFIED: Simplified autoplay logic
  useEffect(() => {
    if (videoData.length > 0 && !videosLoaded) {
      const playAllVideos = async () => {
        try {
          const playPromises = [];

          videoRefs.current.forEach((video, index) => {
            if (video && videoData[index].type === "video" && loadedVideos.has(index)) {
              video.muted = true;
              playPromises.push(
                video
                  .play()
                  .then(() => {
                    setVideoStates((prev) => ({
                      ...prev,
                      [index]: {
                        ...prev[index],
                        isPlaying: true,
                        isMuted: true,
                      },
                    }));
                  })
                  .catch((error) => {
                    console.error(`Error autoplaying video ${index}:`, error);
                    setVideoStates((prev) => ({
                      ...prev,
                      [index]: {
                        ...prev[index],
                        isPlaying: false,
                      },
                    }));
                  })
              );
            }
          });

          await Promise.all(playPromises);
          setVideosLoaded(true);
        } catch (error) {
          console.error("Error autoplaying videos:", error);
        }
      };

      setTimeout(() => {
        playAllVideos();
      }, 100);
    }
  }, [videoData, videosLoaded, loadedVideos]);

  useEffect(() => {
    if (videosLoaded && videoRefs.current[activeVideoIndex] &&
      videoData[activeVideoIndex]?.type === "video") {
      const ensureActiveVideoPlaying = async () => {
        try {
          if (videoRefs.current[activeVideoIndex].paused) {
            await videoRefs.current[activeVideoIndex].play();

            setVideoStates((prev) => ({
              ...prev,
              [activeVideoIndex]: {
                ...prev[activeVideoIndex],
                isPlaying: true,
              },
            }));
          }
        } catch (error) {
          console.error("Error playing active video:", error);
        }
      };

      ensureActiveVideoPlaying();
    }
  }, [activeVideoIndex, videosLoaded, videoData]);

  const toggleMute = (index, e) => {
    e.stopPropagation();

    if (videoData[index].type === "video" && videoRefs.current[index]) {
      const newMutedState = !videoRefs.current[index].muted;
      videoRefs.current[index].muted = newMutedState;

      setVideoStates((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          isMuted: newMutedState,
        },
      }));
    } else if (videoData[index].type === "youtube") {
      const newMutedState = !videoStates[index]?.isMuted;
      const newUrl = getYouTubeEmbedUrl(
        videoData[index].originalUrl,
        1,
        newMutedState ? 1 : 0
      );

      if (youtubeIframeRefs.current[index]) {
        youtubeIframeRefs.current[index].src = newUrl;
      }

      setVideoStates((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          isMuted: newMutedState,
        },
      }));
    }
  };

  const toggleFullscreen = (index, e) => {
    e.stopPropagation();

    setFullscreenVideo({
      index,
      url: videoData[index].url,
      originalUrl: videoData[index].originalUrl,
      type: videoData[index].type,
      isMuted: videoStates[index]?.isMuted,
      isPlaying: videoStates[index]?.isPlaying,
      title: videoData[index].video_title
    });

    if (videoData[index].type === "video" && videoRefs.current[index]) {
      videoRefs.current[index].pause();
    }
  };

  const exitFullscreen = () => {
    if (fullscreenVideo && fullscreenVideo.isPlaying &&
      videoData[fullscreenVideo.index]?.type === "video" &&
      videoRefs.current[fullscreenVideo.index]) {
      videoRefs.current[fullscreenVideo.index].play();
    }

    setFullscreenVideo(null);
  };

  const toggleFullscreenMute = () => {
    if (fullscreenVideo) {
      if (fullscreenVideo.type === "video") {
        setFullscreenVideo((prev) => ({
          ...prev,
          isMuted: !prev.isMuted,
        }));
      } else if (fullscreenVideo.type === "youtube") {
        const newMutedState = !fullscreenVideo.isMuted;
        const newUrl = getYouTubeEmbedUrl(
          fullscreenVideo.originalUrl,
          fullscreenVideo.isPlaying ? 1 : 0,
          newMutedState ? 1 : 0
        );

        if (fullscreenYoutubeRef.current) {
          fullscreenYoutubeRef.current.src = newUrl;
        }

        setFullscreenVideo((prev) => ({
          ...prev,
          isMuted: newMutedState
        }));
      }
    }
  };

  const toggleFullscreenPlayPause = () => {
    if (fullscreenVideo) {
      if (fullscreenVideo.type === "video") {
        if (fullscreenVideoRef.current.paused) {
          fullscreenVideoRef.current.play();
          setFullscreenVideo((prev) => ({ ...prev, isPlaying: true }));
        } else {
          fullscreenVideoRef.current.pause();
          setFullscreenVideo((prev) => ({ ...prev, isPlaying: false }));
        }
      } else if (fullscreenVideo.type === "youtube") {
        const newPlayingState = !fullscreenVideo.isPlaying;
        const newUrl = getYouTubeEmbedUrl(
          fullscreenVideo.originalUrl,
          newPlayingState ? 1 : 0,
          fullscreenVideo.isMuted ? 1 : 0
        );

        if (fullscreenYoutubeRef.current) {
          fullscreenYoutubeRef.current.src = newUrl;
        }

        setFullscreenVideo((prev) => ({
          ...prev,
          isPlaying: newPlayingState
        }));
      }
    }
  };

  const togglePlayPause = (index, e) => {
    e.stopPropagation();
    if (videoData[index].type === "video" && videoRefs.current[index]) {
      if (videoRefs.current[index].paused) {
        videoRefs.current[index].play();

        setVideoStates((prev) => ({
          ...prev,
          [index]: {
            ...prev[index],
            isPlaying: true,
          },
        }));
      } else {
        videoRefs.current[index].pause();

        setVideoStates((prev) => ({
          ...prev,
          [index]: {
            ...prev[index],
            isPlaying: false,
          },
        }));
      }
    } else if (videoData[index].type === "youtube") {
      const newPlayingState = !videoStates[index]?.isPlaying;
      const newUrl = getYouTubeEmbedUrl(
        videoData[index].originalUrl,
        newPlayingState ? 1 : 0,
        videoStates[index]?.isMuted ? 1 : 0
      );

      if (youtubeIframeRefs.current[index]) {
        youtubeIframeRefs.current[index].src = newUrl;
      }

      setVideoStates((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          isPlaying: newPlayingState,
        },
      }));
    }
  };

  const handleVideoClick = (index, e) => {
    e.stopPropagation();
    if (videoData[index].type === "video" || videoData[index].type === "youtube") {
      togglePlayPause(index, e);
    }
  };

  useEffect(() => {
    const playListeners = [];
    const pauseListeners = [];

    videoRefs.current.forEach((video, index) => {
      if (video && videoData[index]?.type === "video") {
        const playHandler = () => {
          setVideoStates((prev) => ({
            ...prev,
            [index]: {
              ...prev[index],
              isPlaying: true,
            },
          }));
        };

        const pauseHandler = () => {
          setVideoStates((prev) => ({
            ...prev,
            [index]: {
              ...prev[index],
              isPlaying: false,
            },
          }));
        };

        video.addEventListener("play", playHandler);
        video.addEventListener("pause", pauseHandler);

        playListeners[index] = playHandler;
        pauseListeners[index] = pauseHandler;
      }
    });

    return () => {
      videoRefs.current.forEach((video, index) => {
        if (video && playListeners[index] && pauseListeners[index]) {
          video.removeEventListener("play", playListeners[index]);
          video.removeEventListener("pause", pauseListeners[index]);
        }
      });
    };
  }, [videoData]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && fullscreenVideo) {
        exitFullscreen();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [fullscreenVideo]);

  if (loading) {
    return (
      <div
        style={{
          backgroundColor: "#e0e0e0",
          padding: "30px 0",
          textAlign: "center",
        }}
      >
        Loading videos...
      </div>
    );
  }

  return (
    <>
      {fullscreenVideo && (
        <div
          ref={fullscreenOverlayRef}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100dvh",
            backgroundColor: "rgba(0, 0, 0, 0.95)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            cursor: "pointer",
          }}
          onClick={exitFullscreen}
        >
          <div
            style={{
              position: "relative",
              maxWidth: "90%",
              maxHeight: "90%",
              width: "auto",
              height: "auto",
              aspectRatio: "9/16",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {fullscreenVideo.type === "video" ? (
              <video
                ref={fullscreenVideoRef}
                src={fullscreenVideo.url}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  backgroundColor: "#000",
                }}
                muted={fullscreenVideo.isMuted}
                loop
                playsInline
                autoPlay={fullscreenVideo.isPlaying}
              />
            ) : (
              <iframe
                ref={fullscreenYoutubeRef}
                src={getYouTubeEmbedUrl(
                  fullscreenVideo.originalUrl,
                  fullscreenVideo.isPlaying ? 1 : 0,
                  fullscreenVideo.isMuted ? 1 : 0
                )}
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                  backgroundColor: "#000",
                }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen={false}
              />
            )}

            {fullscreenVideo.title && (
              <div
                style={{
                  position: "absolute",
                  top: "20px",
                  left: "0",
                  width: "100%",
                  textAlign: "center",
                  color: "white",
                  fontSize: "18px",
                  fontWeight: "bold",
                  textShadow: "2px 2px 4px rgba(0,0,0,0.7)",
                  padding: "0 20px",
                  boxSizing: "border-box",
                  zIndex: 10,
                }}
              >
                {fullscreenVideo.title}
              </div>
            )}

            <div
              style={{
                position: "absolute",
                bottom: "20px",
                left: "0",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                gap: "15px",
                zIndex: 10,
              }}
            >
              <div
                style={{
                  backgroundColor: "rgba(0,0,0,0.5)",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
                onClick={toggleFullscreenPlayPause}
              >
                {fullscreenVideo.isPlaying ? (
                  <MdPause size={24} color="white" />
                ) : (
                  <MdPlayArrow size={24} color="white" />
                )}
              </div>

              <div
                style={{
                  backgroundColor: "rgba(0,0,0,0.5)",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
                onClick={toggleFullscreenMute}
              >
                {fullscreenVideo.isMuted ? (
                  <MdVolumeOff size={24} color="white" />
                ) : (
                  <MdVolumeUp size={24} color="white" />
                )}
              </div>

              <div
                style={{
                  backgroundColor: "rgba(0,0,0,0.5)",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
                onClick={exitFullscreen}
              >
                <MdClose size={24} color="white" />
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="d-flex align-items-center custom-hero-swiper-safari" style={{ backgroundColor: "#e0e0e0", padding: "30px 0"}}>
        <Swiper
          spaceBetween={30}
          freeMode={true}
          loop={true}
          allowTouchMove={true}
          direction={"horizontal"}
          mousewheel={{
            forceToAxis: true,
            releaseOnEdges: true,
            sensitivity: 1,
          }}
          modules={[FreeMode, Pagination, Mousewheel, Navigation]}
          className="mySwiper px-5 px-md-0 px-lg-1"
          style={{ padding: "30px 0" }}
          breakpoints={{
            320: { slidesPerView: 1, spaceBetween: 8 },
            375: { slidesPerView: 1, spaceBetween: 8 },
            425: { slidesPerView: 1, spaceBetween: 8 },
            640: { slidesPerView: 1, spaceBetween: 20 },
            768: { slidesPerView: 3.2, spaceBetween: 24 },
            1025: { slidesPerView: 5.2, spaceBetween: 30 },
          }}
          navigation={true}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          onSlideChange={(swiper) => {
            setActiveVideoIndex(swiper.activeIndex);
          }}
        >
          {videoData.map((item, index) => (
            <SwiperSlide
              key={index}
              style={{ aspectRatio: "9/16", padding: "10px" }}
            >
              <div
                ref={(el) => (containerRefs.current[index] = el)}
                style={{
                  position: "relative",
                  width: "100%",
                  paddingTop: "177.78%",
                  borderRadius: "15px",
                  overflow: "hidden",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  touchAction: "pan-y",
                  backgroundColor: "#fff",
                }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                {/* NEW: Show thumbnail or actual video based on loadedVideos */}
                {!loadedVideos.has(index) && item.type === "youtube" && item.thumbnail ? (
                  // Show thumbnail for unloaded YouTube videos
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundImage: `url(${item.thumbnail})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "rgba(0,0,0,0.6)",
                        borderRadius: "50%",
                        width: "60px",
                        height: "60px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <MdPlayArrow size={36} color="white" />
                    </div>
                  </div>
                ) : item.type === "video" ? (
                  <video
                    ref={(el) => (videoRefs.current[index] = el)}
                    src={item.url}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    muted={true}
                    loop
                    playsInline
                    preload="auto"
                    onClick={(e) => handleVideoClick(index, e)}
                  />
                ) : (
                  <iframe
                    ref={(el) => {
                      youtubeIframeRefs.current[index] = el;
                      videoRefs.current[index] = el;
                    }}
                    src={item.url}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      border: "none",
                    }}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen={false}
                    onClick={(e) => handleVideoClick(index, e)}
                  />
                )}

                {/* Controls */}
                <div
                  style={{
                    position: "absolute",
                    top: "12px",
                    left: "12px",
                    zIndex: 10,
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "rgba(0,0,0,0.5)",
                      borderRadius: "50%",
                      width: "32px",
                      height: "32px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      transition: "background-color 0.2s",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.7)")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.5)")
                    }
                    onClick={(e) => togglePlayPause(index, e)}
                  >
                    {videoStates[index]?.isPlaying ? (
                      <MdPause size={18} color="white" />
                    ) : (
                      <MdPlayArrow size={18} color="white" />
                    )}
                  </div>

                  <div
                    style={{
                      backgroundColor: "rgba(0,0,0,0.5)",
                      borderRadius: "50%",
                      width: "32px",
                      height: "32px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      transition: "background-color 0.2s",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.7)")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.5)")
                    }
                    onClick={(e) => toggleMute(index, e)}
                  >
                    {videoStates[index]?.isMuted ? (
                      <MdVolumeOff size={18} color="white" />
                    ) : (
                      <MdVolumeUp size={18} color="white" />
                    )}
                  </div>

                  <div
                    style={{
                      backgroundColor: "rgba(0,0,0,0.5)",
                      borderRadius: "50%",
                      width: "32px",
                      height: "32px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      transition: "background-color 0.2s",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.7)")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.5)")
                    }
                    onClick={(e) => toggleFullscreen(index, e)}
                  >
                    <MdFullscreen size={18} color="white" />
                  </div>
                </div>

                {hoveredIndex === index && item.video_title && (
                  <div
                    className="custom-hero-sliders-sticker"
                  >
                    <a
                      href={item.video_url || item.originalUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "black",
                        textDecoration: "none",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <span className="me-1">
                        <FaLink className="custom-video-slider-link-icon" />
                      </span>
                      {item.video_title}
                    </a>
                  </div>
                )}
              </div>
            </SwiperSlide>
          ))}
          <div className="py-2 text-center my-4 pb-4">
            <UpcomingTripsBtn />
          </div>
        </Swiper>
      </div>
    </>
  );
};

export default Hero;
